import PageLoading from "@/components/PageLoading";
import { GET_ROCKET_KEY } from "@/graphql/user.graphql";
import useTranslation from "@/hooks/useTranslation";
import CommonLayoutWithAuth from "@/layouts/CommonWithAuth";
import { useQuery } from "@apollo/react-hooks";
import { NextPage } from "next";
import Head from "next/head";
import React, { useEffect } from "react";

const Chat: NextPage = () => {
  const { data } = useQuery(GET_ROCKET_KEY);
  const { t } = useTranslation("menu");

  useEffect(() => {
    if (data) {
      window.location.assign(
        `https://rc.medicgo.org/channel/medicgo?resumeToken=${data?.getRocketToken}`
      );
    }
  }, [data]);

  return (
    <CommonLayoutWithAuth>
      <Head>
        <title>
          {t("about.chat")} - {t("about.itself")} - MedicGo
        </title>
      </Head>
      <PageLoading />
    </CommonLayoutWithAuth>
  );
};

Chat.getInitialProps = async (ctx) => {
  return {
    namespacesRequired: ["menu", "common"],
  };
};

export default Chat;
